// A Calendar board in small, for its tile in All boards: this week's days side by side, eight in the morning to eight
// at night, each event a block where it sits, in its own color, and the all-day ones along the top.

import { BOARD_CAL, calSetOf, eventTitle, eventsBetween, isEvent, partsOn, shownOf, touches, viewSpan } from "../../../shared/agenda";
import { addDays, dayOf, weekdayName, weekdayOf } from "../../../shared/days";
import type { Board, Entry } from "../../../shared/types";
import { cx } from "../../lib/util";
import { zoneHere } from "./actions";
import { evStyle } from "./parts";
import { startsOn } from "./state";

export function AgendaThumb({ board, entries }: { board: Board; entries: Entry[] }) {
  const today = dayOf(new Date());
  const [first] = viewSpan("week", today, startsOn);
  const days = Array.from({ length: 7 }, (_, i) => addDays(first, i));
  const zone = zoneHere();
  // each time a repeat happens this week too
  const list = calSetOf(entries, board.id).hidden.includes(BOARD_CAL) ? [] : eventsBetween(entries, days[0], days[6], zone);
  const from = 8 * 60;
  const span = 12 * 60;
  return (
    <div className="ov-doc ov-ag">
      {days.map((d) => (
        <div key={d} className={cx("ov-ag-day", d === today && "is-today")}>
          <b>
            {weekdayName(weekdayOf(d), true)} {Number(d.slice(8))}
          </b>
          <span className="ov-ag-all">
            {list
              .filter((s) => (s.allDay || s.long) && touches(s, d, d))
              .slice(0, 2)
              .map((s) => (
                <i key={s.id} style={evStyle(s.ev)}>
                  {eventTitle(s.ev)}
                </i>
              ))}
          </span>
          <span className="ov-pl-time ov-ag-time">
            {partsOn(list, d)
              .filter((p) => p.start < from + span && p.end > from)
              .map((p) => {
                const a = Math.max(from, p.start);
                const b = Math.min(from + span, p.end);
                return (
                  <i key={p.shown.id} className="ov-ag-blk" style={{ ...evStyle(p.shown.ev), top: `${((a - from) / span) * 100}%`, height: `${Math.max(4, ((b - a) / span) * 100)}%` }}>
                    {eventTitle(p.shown.ev)}
                  </i>
                );
              })}
          </span>
        </div>
      ))}
    </div>
  );
}

/** What All boards says it holds: the events from today on. */
export function agendaCount(entries: Entry[]): string {
  const today = dayOf(new Date());
  const zone = zoneHere();
  const n = entries.filter(isEvent).filter((e) => (e.data as { repeat?: unknown }).repeat || shownOf(e, zone).last >= today).length;
  return n === 1 ? "1 event coming up" : n ? `${n} events coming up` : "nothing coming up";
}
